module.exports = __webpack_public_path__ + "media/assets/images/blog/certifications-9d417e0efcdd090d710e32ca539f1325.jpg";